import React from "react";
import img from "../img/header.png";

export default function Header() {
  return (
    <div className="img-cont">
      <img src={img} />
    </div>
  );
}
